<template>
  <div class="myevents container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">My Schedule</h4>
              </div>
            </div>
          </div>
          <b-card no-body id="myscheduleDYCard" class="p-3">
            <FullCalendar
              id="fullCalendarDY"
              :options="calendarOptions"
              :eventsources="calendarOptions.eventSources"
              :config="config"
            >
            </FullCalendar>
            <b-modal
              id="event-info-modal-dy"
              modal-class="modal-doom-yoga"
              body-class="px-4 py-3"
              size="sm"
              centered
              title="Event Info"
              title-class="modal-title-dy"
              hide-footer
            >
              <b-row class="mt-2"
                ><b-col>
                  <p class="event-data-calendar-dy-p">
                    {{ selected_event_title }}
                  </p>
                </b-col></b-row
              >
              <!-- <b-row class="mt-2"
        ><b-col>
          <b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/class-type-icon-book.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="event-data-calendar-dy-p">{{ selected_event_description }}</p>
          </b-input-group>
        </b-col></b-row
      > -->
              <b-row class="mt-2"
                ><b-col>
                  <p class="event-data-calendar-dy-p">
                    {{ selected_event_date }}
                  </p>
                </b-col></b-row
              >
              <b-row class="mt-2"
                ><b-col>
                  <p class="event-data-calendar-dy-p">
                    {{ selected_event_time }}
                  </p>
                </b-col></b-row
              >
              <b-row class="mt-2"
                ><b-col>
                  <p class="event-data-calendar-dy-p">
                    No. booked users: {{ selected_event_booked_users }}
                  </p>
                </b-col></b-row
              >
              <b-row class="mt-2"
                ><b-col>
                  <p class="event-data-calendar-dy-p">
                    <router-link
                      :to="'/join_event/' + selected_event_call_url+'/'+selected_event_title"
                      target="_blank"
                      class="card-link eventLink"
                    >
                      Join event
                    </router-link>
                    <!-- {{ selected_event_call_url }} -->
                  </p>
                </b-col></b-row
              >
            </b-modal>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import $ from "jquery";
import moment from "moment";

import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data() {
    return {
      selected_event_title: null,
      selected_event_date: null,
      selected_event_time: null,
      selected_event_booked_users: null,
      selected_event_call_url: null,
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        // displayEventTime: true,
        headerToolbar: {
          // left: 'title',
          // left:'prev title next',
          // center: 'agendaDay,agendaWeek,month,agendaYear',
          // right:'today',
          left: "prev next title",
          center: "today",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
          // center: 'agendaDay,agendaWeek,month',
          // right: 'prev,next today'
        },
        eventLimit: true,

        dayMaxEvents: 2,

        // Dynamic Event Source
        eventSources: [
          {
            events(start, callback) {
              console.log(start.start, start.end);
              axios
                .get("event/calendar", {
                  params: { from: start.start, to: start.end },
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    client: "DY",
                    Authorization:
                      "Bearer " +
                      JSON.parse(window.localStorage.getItem("user"))
                        .access_token,
                  },
                })
                .then((response) => {
                  console.log(response);
                  callback(response.data);
                });
            },
          },
        ],
        events: [],
        eventClick: (info) => {
          console.log("event");
          console.log(info);
          console.log(info.jsEvent.screenX, info.jsEvent.screenY);
          console.log(info.event.title, info.event.start, info.event.end);

          let start = info.event.start,
            end = info.event.end;

          this.selected_event_title = info.event.title;
          this.selected_event_date = moment(start).format("ddd, DD MMM YYYY");
          this.selected_event_time =
            moment(start).format("hh:mm a") +
            " - " +
            moment(end).format("hh:mm a");
          this.selected_event_booked_users =
            info.event._def.extendedProps.booked_users;
          this.selected_event_call_url =
            info.event._def.extendedProps.meeting_id;

          this.$bvModal.show("event-info-modal-dy");
        },
      },
      config: {},
    };
  },

  methods: {},
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/Calendar.vue